// extracted by mini-css-extract-plugin
export var emailBlockLink = "_i5-0";